module.exports = __webpack_public_path__ + "img/itx-file-type-pptx.c7c2c3a1.svg";